function formatSubresources(resources) {
  return `subResource=${resources.join("&subResource=")}`;
}
var formatSubresources_default = formatSubresources;
export {
  formatSubresources_default as default
};
